<template>
  <Layout>
    <div v-if="$store.state.general.currentUserAccountDetails?.featureFlags?.new_agent_training_course">
      <h1 class="block text-2xl font-bold leading-6 text-gray-900">Humaniz University</h1>
      <div v-if="course" class="w-full px-8 mt-12">
        <h1 class="font-bold text-lg">Courses</h1>

        <div class="mt-8 grid gap-4 xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 grid-cols-1">
          <router-link
            :to="`/agents/university/courses/${course.id}`"
            :key="course.id"
            class="rounded overflow-hidden border border-gray-200 hover:scale-[1.05] transition-all cursor-pointer"
          >
            <div
              class="h-48 bg-center bg-cover"
              :style="{
                backgroundImage: `url('${course.featured_image_url}')`,
              }"
            ></div>
            <div class="p-8">
              <header class="font-bold text-gray-800">{{ course.name }}</header>
              <p class="text-gray-600">{{ course.description }}</p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import { mapState } from 'vuex';
import Card from '../components/Card/index.vue';
import Layout from '../components/Layout/index.vue';

export default {
  components: {
    Card,
    Layout,
  },
  data() {
    return {
      userId: null,
      courseData: {
        course: null,
      },
    };
  },
  computed: {
    ...mapState({
      user: state => state.general.currentUser,
      currentUserAccountDetails: state => state.general.currentUserAccountDetails,
    }),
    course() {
      return this.courseData?.course;
    },
  },
  async mounted() {
    if (this.currentUserAccountDetails.role !== 'Agent') {
      await this.$router.push('/');
    }

    await Promise.all([this.$store.dispatch('general/loadCurrentUser'), this.loadCourseData()]);
    const { id: userId } = this.user;
    this.userId = userId;
  },
  methods: {
    async loadCourseData() {
      const res = await fetch(`/api/agent_training_course`);
      const { course } = await res.json();
      this.courseData.course = course;
    },
  },
};
</script>
